import React, { useRef } from "react";
import TextareaAutosize from "react-textarea-autosize";
import PropTypes from "prop-types";

import { t } from "../../services";
import { useBulletList } from "./hooks/useBulletList";

import Input from "./Input";

const TextArea = ({
  id,
  title,
  value,
  setValue,
  onKeyDown,
  placeholder,
  maxLength,
  isRequired,
  disabled,
  hasError,
  viewOnly,
  isBulletList
}) => {
  const textAreaRef = useRef(null);

  const { handleFocus, handleSetValue, handleEnterKeyDown } = useBulletList({
    id,
    isBulletList,
    textAreaRef,
    value,
    disabled,
    setValue,
    onKeyDown
  });

  return (
    <Input
      id={id}
      title={title}
      value={value}
      setValue={setValue}
      onKeyDown={handleEnterKeyDown}
      placeholder={placeholder}
      maxLength={maxLength}
      isRequired={isRequired}
      disabled={disabled}
      hasError={hasError}
      viewOnly={viewOnly}
      hideInputComponentWrapper
      InputComponent={
        <TextareaAutosize
          id={id}
          data-testid="textarea"
          ref={textAreaRef}
          maxRows={4}
          value={value}
          placeholder={placeholder && t(placeholder)}
          onChange={(e) => {
            if (maxLength ?? 0 > 0) {
              e.target.value.length <= maxLength && handleSetValue(e.target.value);
            } else {
              handleSetValue(e.target.value);
            }
          }}
          onFocus={handleFocus}
          onKeyDown={handleEnterKeyDown}
          disabled={disabled}
        />
      }
    />
  );
};

TextArea.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setValue: PropTypes.func,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  hasError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  viewOnly: PropTypes.bool,
  isBulletList: PropTypes.bool
};

export default TextArea;
